import type { SupportChatFeatureConfig } from './type';
import { SupportChatExternalAuthorizationMethod, SupportChatLanguage } from './type';

export const supportChat: SupportChatFeatureConfig = {
    channelId: '',
    externalAuthorizationMethod: SupportChatExternalAuthorizationMethod.PROPERTY,
    externalAuthorizationTokenExchangeKeepAccessTokenInCookie: false,
    externalSupportChat: false,
    fallbackLanguage: SupportChatLanguage.EN,
    languagePackage: '',
    showClientIdentity: true,
    supportedLanguages: [SupportChatLanguage.EN],
    useInvalidationWhenSessionExpired: false,
    displayChatStatus: false,
    useAuthenticatedFlag: false,
    proactiveChatAutoHideInput: true,
    proactiveChatChannelId: '',
};
